import { GlobalActions, GlobalEventDispatcher } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { AxiosResponse } from 'axios';
import { environment } from '../../../environments/environment';

let lastBffVersionFromHeader: string = null;
export const BFF_VERSION_HEADER_KEY = 'x-ps20-bff-version';

export function handleBffVersionHasChanged(resp: AxiosResponse): boolean {
  if (resp.config.url?.includes(environment.bffBaseUrl)) {
    return false;
  }
  if (!resp.config.url?.includes('privatschutz/api')) {
    return false;
  }
  if (!resp?.headers?.[BFF_VERSION_HEADER_KEY]) {
    throw new Error('handleBffVersionHasChanged: Kann BFF-Version nicht bestimmen');
  }

  if (!lastBffVersionFromHeader) {
    lastBffVersionFromHeader = resp.headers[BFF_VERSION_HEADER_KEY];
    GlobalEventDispatcher.getInstance().dispatch(
      new GlobalActions().bffVersionUpdated(resp.headers[BFF_VERSION_HEADER_KEY]),
    );
    return false;
  }

  if (lastBffVersionFromHeader !== resp.headers[BFF_VERSION_HEADER_KEY]) {
    GlobalEventDispatcher.getInstance().dispatch(new GlobalActions().appHasBeenUpdated(App.SHOP));
    GlobalEventDispatcher.getInstance().dispatch(
      new GlobalActions().bffVersionUpdated(resp.headers[BFF_VERSION_HEADER_KEY]),
    );
    return true;
  }

  return false;
}

export function resetLastBffVersionFromHeader(): void {
  lastBffVersionFromHeader = null;
}
